import { render, staticRenderFns } from "./SpoiledChangelog.vue?vue&type=template&id=094e48ee&scoped=true&"
import script from "./SpoiledChangelog.vue?vue&type=script&lang=js&"
export * from "./SpoiledChangelog.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledChangelog.vue?vue&type=style&index=0&id=094e48ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094e48ee",
  null
  
)

export default component.exports